module.exports = __webpack_public_path__ + "static/img/200302.f24e883b.png";